import { toast } from "sonner";
import api from "@/lib/api";

export const UNDO_MS = 5000;

// Floating top-right toast with an Undo action; resolves via POST /undo/{id}, or a custom onUndo callback.
export function undoToast(message, undoId, onRestore, opts = {}) {
  const id = toast(message, {
    duration: UNDO_MS,
    position: "top-right",
    action: (undoId || opts.onUndo) ? {
      label: "Undo",
      onClick: async () => {
        try {
          const data = opts.onUndo ? await opts.onUndo() : (await api.post(`/undo/${undoId}`)).data;
          toast.dismiss(id);
          toast.success("Restored");
          onRestore?.(data);
        } catch (e) {
          toast.error(e?.response?.data?.detail || "Could not undo — the change is already final");
        }
      },
    } : undefined,
  });
  return id;
}
